/**
 * BUG-008 (BATCH 109) — Form.io (formiojs 4.14) single-file fields lost their drop zone for good.
 *
 * On picking a file the component sets `fileDropHidden = true` before checking it. When the file is
 * refused (wrong type / too big) and the user removes that error row with ✕, nothing sets the flag
 * back, so "Drop files to attach, or browse" never returns — the project Banner could then only be
 * added by reloading the page and losing everything typed.
 *
 * Patched once, for every Form.io form: the drop zone is hidden only while a file is really held
 * or an upload is in progress. A refused file leaves it visible, so another one can be picked.
 */
import { Components } from 'formiojs';

const FileComponent: any = (Components as any)?.components?.file;
const proto = FileComponent?.prototype;
const desc = proto && Object.getOwnPropertyDescriptor(proto, 'fileDropHidden');

if (proto && desc && desc.get && desc.set && !proto.__vdDropzonePatched) {
  Object.defineProperty(proto, 'fileDropHidden', {
    configurable: true,
    get(this: any) {
      if (!desc.get!.call(this)) return false;
      const value = this.dataValue;
      const holdsFile = Array.isArray(value) ? value.length > 0 : !!value;
      const uploading = (this.statuses || []).some((s: any) => s && s.status === 'progress');
      return holdsFile || uploading;
    },
    set(this: any, v: boolean) {
      desc.set!.call(this, v);
    },
  });
  proto.__vdDropzonePatched = true;
}

export {};
